/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GeoJsonMultiPolygon } from './GeoJsonMultiPolygon';
import {
    instanceOfGeoJsonMultiPolygon,
    GeoJsonMultiPolygonFromJSON,
    GeoJsonMultiPolygonFromJSONTyped,
    GeoJsonMultiPolygonToJSON,
} from './GeoJsonMultiPolygon';
import type { GeoJsonPolygon } from './GeoJsonPolygon';
import {
    instanceOfGeoJsonPolygon,
    GeoJsonPolygonFromJSON,
    GeoJsonPolygonFromJSONTyped,
    GeoJsonPolygonToJSON,
} from './GeoJsonPolygon';

/**
 * @type TerritoryWithPolygonResponseGeoJson
 * Territory geometry (Polygon or MultiPolygon)
 * @export
 */
export type TerritoryWithPolygonResponseGeoJson = { type: 'MultiPolygon' } & GeoJsonMultiPolygon | { type: 'Polygon' } & GeoJsonPolygon;

export function TerritoryWithPolygonResponseGeoJsonFromJSON(json: any): TerritoryWithPolygonResponseGeoJson {
    return TerritoryWithPolygonResponseGeoJsonFromJSONTyped(json, false);
}

export function TerritoryWithPolygonResponseGeoJsonFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerritoryWithPolygonResponseGeoJson {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'MultiPolygon':
            return Object.assign({}, GeoJsonMultiPolygonFromJSONTyped(json, true), { type: 'MultiPolygon' } as const);
        case 'Polygon':
            return Object.assign({}, GeoJsonPolygonFromJSONTyped(json, true), { type: 'Polygon' } as const);
        default:
            return json;
    }
}

export function TerritoryWithPolygonResponseGeoJsonToJSON(json: any): any {
    return TerritoryWithPolygonResponseGeoJsonToJSONTyped(json, false);
}

export function TerritoryWithPolygonResponseGeoJsonToJSONTyped(value?: TerritoryWithPolygonResponseGeoJson | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'MultiPolygon':
            return Object.assign({}, GeoJsonMultiPolygonToJSON(value), { type: 'MultiPolygon' } as const);
        case 'Polygon':
            return Object.assign({}, GeoJsonPolygonToJSON(value), { type: 'Polygon' } as const);
        default:
            return value;
    }
}

